import { GenericItem } from '@navix/ui/common'
import { Role } from '../domain/role.model'
import { AdapterBase } from '@navix/utils/adapter'

export class ToRoleAdapter extends AdapterBase<unknown, Role[] | Role> {}
export class FromRoleAdapter extends AdapterBase<Role[] | Role, unknown> {}
export class ToGenericItemAdapter extends AdapterBase<unknown, GenericItem[]> {}
